// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Tobias",
  bookSlug: "tobias",
  chapter: 9,
  argument: "The angel, Raphael, goeth to Gabelus, receiveth the money, and bringeth him to the marriage.",
  verses: [
    { n: 1, text: "Then Tobias called the angel to him, whom he took to be a man, and said to him: Brother Azarias, I pray thee hearken to my words:" },
    { n: 2, text: "If I should give myself to be thy servant, I should not make a worthy return for thy care." },
    { n: 3, text: "However, I beseech thee, to take with thee beasts and servants, and to go to Gabelus, to Rages, the city of the Medes: and to restore to him his note of hand, and receive of him the money, and desire him to come to my wedding." },
    { n: 4, text: "For thou knowest that my father numbereth the days: and if I stay one day more, his soul will be afflicted." },
    { n: 5, text: "And, indeed, thou seest how Raguel hath adjured me, whose adjuring I cannot despise." },
    { n: 6, text: "Then Raphael took four of Raguel's servants, and two camels, and went to Rages, the city of the Medes: and finding Gabelus, gave him his note of hand, and received of him all the money." },
    { n: 7, text: "And he told him concerning Tobias, the son of Tobias, all that had been done: and made him come with him to the wedding." },
    { n: 8, text: "And when he was come into Raguel's house, he found Tobias sitting at the table: and he leaped up, and they kissed each other: and Gabelus wept, and blessed God," },
    { n: 9, text: "And said: The God of Israel bless thee, because thou art the son of a very good and just man, and that feareth God, and doth alms-deeds:" },
    { n: 10, text: "And may a blessing come upon thy wife, and upon your parents." },
    { n: 11, text: "And may you see your children, and your children's children, unto the third and fourth generation: and may your seed be blessed by the God of Israel, who reigneth for ever and ever." },
    { n: 12, text: "And when all had said, Amen; they went to the feast: but the marriage feast they celebrated, also, with the fear of the Lord." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "The angel. Greek, \"Raphael, and said.\" — I pray. Greek, \"Take with thee a servant and two camels,\"", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Rages. Tobias remained in the province of the same name, chap. iii. 7. (Worthington) — And to. Greek, \"Bring me the money and him to the marriage feast.\"", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Whose. Greek, \"that I should not go out, and my father,\" &c.,", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "(Haydock) — Tobias finds out an expedient to shew his respect for God, his father, and his friend, (Calmet) without retarding the business for which he came.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Lord. Not giving too much way to pleasure, (Haydock) or gluttony, as Plato beautifully commends. (Leg. vi.; Serarius)", attribution: "Worthington" }
    ] },
  ],
};

export default chapter;
